import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable max-len */
import classNames from 'classnames';
import s from './contentBlock.module.scss';
export const ContentBlock = ({ children, className, onClick }) => _jsx("div", { className: classNames(s.inner, className), onClick: onClick, children: _jsx("div", { className: s.content, children: children }) });
